var _rect, _path, _line, _line2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EFF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9C10.5555 10.9444 8.33331 15 8.33331 15.6667H9.16665H19.1666V4L15 11.5L11.6666 9Z",
    fill: "url(#paint0_linear_999_16643)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 18.1666,
    x2: 6.66667,
    y2: 18.1666,
    stroke: "url(#paint1_linear_999_16643)",
    strokeWidth: 1.66667
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.83333,
    y1: 4,
    x2: 5.83333,
    y2: 19,
    stroke: "url(#paint2_linear_999_16643)",
    strokeWidth: 1.66667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_999_16643",
    x1: 9.16665,
    y1: 15.6667,
    x2: 19.1666,
    y2: 3.16667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AAFEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1966C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_999_16643",
    x1: 13.3333,
    y1: 17.3333,
    x2: 13.3333,
    y2: 16.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ABEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E72CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_999_16643",
    x1: 5,
    y1: 11.5,
    x2: 4,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ABEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E72CA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.db0911d768375212f8ef5b5fa772ec1f.svg";
export { ForwardRef as ReactComponent };